<template>
  <div :class="type" class="banner">
    <img :src="bannerImg" alt="banner">
    <!-- <div class="title" :class="locale"></div> -->
    <!-- <div class="banner-bg"></div> -->
    <!-- <div class="banner-line"></div> -->
  </div>
</template>

<script setup>
/* eslint-disable no-unused-vars */
import { isMobile } from '@/utils'
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import bannerImgMap from '@/assets/imgs/banner/index.js'
import mobileBannerImgMap from '@/assets/imgs/m/banner/index.js'
const type = isMobile ? 'mobile' : 'pc'
const { locale } = useI18n()
const bannerImg = computed(() => type === 'mobile' ? mobileBannerImgMap[locale.value] : bannerImgMap[locale.value])
</script>

<style src="./pc_style.less" lang="less" scoped></style>
<style src="./mobile_style.less" lang="less" scoped></style>
